angular
    .module("invitesTable.components", [])
    .component("invitesTable", {
        templateUrl: 'ng/components/invitesTable/invitesTable.view.html',
        bindings: {
            listaPf: '=',
            dealerUser: '<',
            canProceed: '&',
            cantProceed: '&',
            enabledPep: '='
        },
        controllerAs: 'invitesTableCtrl',
        controller: function (
            $scope,
            validationService) {

            var self = this;



            self.$onInit = function () {
                self.errorCf = [];
                self.lista = self.listaPf.filter(function (element) {
                    return element.cf != self.dealerUser.identifier && element.firmatario.selected == true
                });

                self.lista.forEach(function (x) {
                    x.nome = "";
                    x.cognome = "";
                })

                self.enabledPep = self.lista.some(function (element) {
                    return element.titolare.selected == true;
                })

            }

            self.validateForm = function (pf, index) {
                var isCorrect = false;

                if (pf) {
                    var checkValidity = validationService.checkCfWithName(pf.cf, pf.cognome, pf.nome);
                    self.errorCf[index] = !checkValidity;
                    if (checkValidity) {

                        $('#cf-' + index).removeAttr("data-toggle");
                        $('#cf-' + index).removeAttr("data-original-title");
                        $('#cf-' + index).removeAttr("title");
                        isCorrect = true;
                    } else {
                        $('#cf-' + index).attr("data-toggle", "tooltip");
                        $('#cf-' + index).attr("data-original-title", "Dati incoerenti");
                        $('#cf-' + index).attr("title", "Dati incoerenti");
                        isCorrect = false;
                    }

                }

                if ($scope.PfForm && $scope.PfForm.$valid && isCorrect) {
                    self.canProceed();
                } else {
                    self.cantProceed();
                }

            }


        }
    })